import { useSettings } from '@wix/tpa-settings/react';
import { InfoCircle } from '@wix/wix-ui-icons-common';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import type { FC } from 'react';
import React from 'react';
import { Tooltip } from 'wix-ui-tpa/cssVars';

import { useCanEditMember } from '../../../../../contexts/widgets';
import type { CustomProfile } from '../../../../../types';
import settingsParams from '../../../settingsParams';
import SectionTitle from '../../common/SectionTitle';
import { classes, st } from './Title.st.css';

interface TitleProps {
  customProfile: CustomProfile;
}

interface ShouldShowHelpTooltipOptions {
  customProfile: CustomProfile;
  canEditMember: boolean;
  isMobile: boolean;
}

const shouldShowHelpTooltip = ({
  customProfile: { fields, socialLinks },
  canEditMember,
  isMobile,
}: ShouldShowHelpTooltipOptions) => {
  return (
    !isMobile && canEditMember && (fields.length > 0 || socialLinks.length > 0)
  );
};

export const Title: FC<TitleProps> = ({ customProfile }) => {
  const { canEditMember } = useCanEditMember();
  const { isMobile } = useEnvironment();
  const { t } = useTranslation();
  const settings = useSettings();

  const htmlTag = settings.get(settingsParams.sectionTitleHtmlTag);

  return (
    <div className={st(classes.root)}>
      <SectionTitle htmlTag={htmlTag}>
        {settings.get(settingsParams.overviewSectionTitle)}
      </SectionTitle>
      {shouldShowHelpTooltip({
        customProfile,
        canEditMember,
        isMobile,
      }) && (
        <Tooltip
          content={t('about.widget.overview-tooltip')}
          placement="top-end"
          minWidth={200}
        >
          <InfoCircle className={classes.icon} />
        </Tooltip>
      )}
    </div>
  );
};
